// @flow

import React from "react";
import { Helmet } from "react-helmet";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon
} from "react-share";

const XIcon = ({ size }) => {
  const path =
    "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z";
  return (
    <svg viewBox="0 0 64 64" width={size} height={size}>
      <circle cx="32" cy="32" r="32" fill={"#000000"} />
      <path d={path} fill="white" />
    </svg>
  );
};

const SomeShareContainer = ({
  facebook,
  twitter,
  linkedin
}: {
  facebook?: {
    url: string,
    appId?: string,
    quote?: string,
    title?: string,
    image?: string,
    description?: string
  },
  twitter?: {
    url: string,
    title?: string
  },
  linkedin?: {
    url: string,
    title?: string
  }
}) => {
  const shareUrl = window.location.href;
  const title = window.document.title;
  return (
    <div className="someshare_container">
      <div className="someshare">
        <FacebookShareButton
          url={facebook ? facebook.url : shareUrl}
          quote={facebook && facebook.quote ? facebook.quote : null}
          className="share-button"
        >
          <FacebookIcon size={32} round />
          {facebook && (
            <Helmet>
              <meta property="og:url" content={shareUrl} />
              <meta property="og:type" content="website" />
              facebook.appId && (<meta
                property="fb:app_id"
                content={facebook.appId}
              />) facebook.title && (<meta
                property="og:title"
                content={facebook.title}
              />) facebook.image && (<meta
                property="og:image"
                content={facebook.image}
              />) facebook.description && (<meta
                property="og:description"
                content={facebook.description}
              />)
            </Helmet>
          )}
        </FacebookShareButton>
      </div>

      <div className="someshare">
        <TwitterShareButton
          url={twitter ? twitter.url : shareUrl}
          title={twitter && twitter.title ? twitter.title : title}
          className="share-button"
        >
          <XIcon size={32} />
        </TwitterShareButton>
      </div>

      <div className="someshare">
        <LinkedinShareButton
          url={linkedin ? linkedin.url : shareUrl}
          title={linkedin && linkedin.title ? linkedin.title : title}
          windowWidth={750}
          windowHeight={600}
          className="share-button"
        >
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </div>

      <div className="someshare">
        <WhatsappShareButton
          url={shareUrl}
          title={title}
          separator=":: "
          className="someshare__share-button"
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>

      <div className="someshare">
        <EmailShareButton
          url={shareUrl}
          subject={title}
          body={shareUrl}
          className="share-button"
        >
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default SomeShareContainer;



// WEBPACK FOOTER //
// ./src/components/reusable/SomeShareContainer.js